import App from 'app/app.js';

// original code from:
// http://stackoverflow.com/questions/29227213/input-allow-only-6-digits-and-after-comma-seperated-and-allow-another-6-digits-i

function LtNumericOnlyDirective() {
  return {
    require: 'ngModel',
    link: function (scope, element, attrs, modelCtrl) {
      modelCtrl.$parsers.push(function (inputValue) {
        if (inputValue === undefined) {
          return '';
        }
        var transformedInput = inputValue.replace(/\D/g, '');
        if (transformedInput !== inputValue) {
          modelCtrl.$setViewValue(transformedInput);
          modelCtrl.$render();
        }
        return transformedInput;
      });
    }
  };
}

App.directive('ltNumericOnly', [LtNumericOnlyDirective]);
